import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/pages/main'
import Login from '@/pages/login/login'
import Info from '@/pages/info/info'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path:'/main',
      name:'Main',
      component:Main
    },
    {
      path:'/main/:activeIndex',
      name:'Main',
      component:Main
    },
    {
      path:'/login',
      name:'Login',
      component:Login
    },
    {
      path:'/info/:id',
      name:'Info',
      component:Info
    },
  ]
})
router.beforeResolve((to , from ,next) => {
  next();
})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js